import styled from "@emotion/styled";

export const Container = styled.div`
	position: absolute;
	top: 1em;
	right: 1em;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5em;
`;

export const ClubDescriptionWidget = styled.div`
	border-radius: 8.4779em;
	background: rgba(255, 255, 255, 0.6);

	p {
		position: relative;
		color: #6d6d6d;
		font-family: "Inter";
		font-size: 1.6em;
		font-style: normal;
		font-weight: 700;
		line-height: 1.125em;
		margin: 0;
		padding: 0.39375em 1.0625em;
	}
`;

export const Button = styled.button`
	background-color: unset;
	border: unset;
	cursor: pointer;
	font-size: inherit;

	svg {
		width: 2.55em;
		height: 2.55em;
	}

	&:hover {
		circle {
			fill-opacity: 0.8;
		}
	}
`;
